define(function (require) {

	const tpl = require('./templates/t_itv_detail.hbs');

	const DetailPageModel = require('civicsModels/core/detail_page_model');
	const DetailObjectModel = require('civicsModels/core/detail_object_model');
	const ViewManager = require('civicsUtils/view_manager');
	const ViewBindingManager = require('civicsUtils/view_binding_manager');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const DetailViewBase = require('./v_itv_detail_base');
	const utils = require('civicsUtils/general_utilities');
	const ModalDetails = require('./modal_view/v_lov_modal_detail.js');

	return DetailViewBase.extend({
		template: tpl,
		FILTERCODEMODELID: '',
		className:'t_itv_detail',
		onRender: function () {

			// if (this.agencyDataReady) {
			// 	if (this.isGrid) {
			// 		//if this is a grid, pass the entire collection so the view binding manager knows how to project the binds.
			// 		ViewBindingManager.bindView(this, this.m);
			// 	}
			// 	else {
			// 		ViewBindingManager.bindView(this, this.m.models[0]);
			// 	}
			// }
			// this.ui.dates.each(function (index, el) {
			// 	var date = $(this).val();//2/1/2018
			// 	$(this).val(Handlebars.helpers['global:formatDate'](date));
			// });
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

			var moniker;
			if ( this.mDetailPage ) moniker = this.mDetailPage.get('detailPage.childMoniker');
			if (moniker) {
				ViewManager.setupAutoComplete(this,moniker);
				this.FILTERCODEMODELID = moniker;
				this.setupFilterCodes(moniker, true, true);
			}

			ViewManager.resetErrorMessages(this, true);

			if(this.enabled){
				window.addEventListener("beforeunload", this.areYouSure.bind(this));
			}
		},
		deleteCollectionItems:function(){
			var self = this;
			var dfd = $.Deferred();
			var promises = [];
			// if the tbale items were removed by the auto complete or any auto process, we need to process them out of the grids
			var tables = this.$el.find('table');
			if (tables.length > 0) {
				_.forEach(tables, table => {
					self.processGridItemToDelete($(table));
				});
			}

			if ( this.modelsToDelete && this.modelsToDelete.length>0 ){
				_.forEach(this.modelsToDelete, m => {
					if (self.m.models && self.m.models.length > 0 && (ViewManager.versionRange('8.7.0.1912', '8.8') || ViewManager.versionRange('8.8.0.2001'))) {
						m.set('aggregaterootid', self.m.models[0].get(self.mDetailPage.get('detailPage.childPrimaryKey')));
					}
					promises.push(this.deleteCollectionItem(m));
				});
				$.when.apply($, promises).done(function(){
					self.modelsToDelete = [];
					dfd.resolve();
				})
				.fail(function(){
					dfd.reject();
				});
			}
			else {dfd.resolve();}
			return dfd.promise();
		},
		deleteCollectionItem:function(m){
			var dfd = $.Deferred();
			m.destroy()
				.done(function (response, status, xhrResponse) {
					dfd.resolve();
				})
				.fail(function (response, status, xhrResponse) {
					ViewManager.errorToWindow(response);
					dfd.reject();
				});
			return dfd.promise();
		},
		removeDeletedRows:function() {
			var promise = $.Deferred();
			if (this.detailView) {
				var data = this.detailView.getDeletedRows();
				if (data != null && data.length > 0) {
					var promiseArray = [];
					data.forEach(deleteMe => {
						var deletePromise = $.Deferred();
						promiseArray.push(deletePromise);
						if (!this.isGrid && (ViewManager.versionRange('8.7.0.1912', '8.8') || ViewManager.versionRange('8.8.0.2001'))) {
							deleteMe.set('aggregateroot', this.mDetailPage.get('detailPage.childMoniker'));
							deleteMe.set('aggregaterootid', this.m.models[0].get(this.mDetailPage.get('detailPage.childPrimaryKey')));
						} else {
							deleteMe.unset('aggregaterootbind');
						}

						if (this.isGrid) {
							deleteMe.moniker = this._getChildMoniker(true);
						}
						deleteMe.sendAsQueryString = true;

						deleteMe.destroy().done(function (response, status, xhrResponse) {
							deletePromise.resolve();
						}).fail(function (response, status, xhrResponse) {
							ViewManager.errorToWindow(response);
							deletePromise.reject();
						});
					});
					$.when.apply($, promiseArray).done(() => {
						promise.resolve();
					})
				} else {
					promise.resolve();
				}
			} else {
				promise.resolve();
			}
			return promise;
		},
		saveDetailClicked: function () {
			var self = this;
			var data = this.getData();
			var promises = [];
			var modelFetch = $.Deferred();
			promises.push(modelFetch);

			this.agencyDataReady = false;
			ViewManager.resetErrorMessages(this);
			ViewManager.loading(true);
			var valid = true;
			// when saveDetail is triggererd, the agency object should not be a grid.
			if (!this.isGrid) {
				valid = ViewManager.validatePageControl(this, true);//pass in true to force validation by IDs
				if (valid) {
					promises.push(this.removeDeletedRows());
					this.mDetailObject = new DetailObjectModel();
					var pkComminId = this.mDetailPage.get('detailPage.childPrimaryKey')
					this.mDetailObject = _.extend(this.mDetailObject, {'idAttribute': pkComminId});
					this.mDetailObject.moniker = this.mDetailPage.get('detailPage.childMoniker');
					if (this.selects)
						this.mDetailObject.selects = this.selects;

					if ( this.m.models && this.m.models.length > 0){
						data[this.mDetailPage.get('detailPage.childPrimaryKey')] = this.m.models[0].get(this.mDetailPage.get('detailPage.childPrimaryKey'));
					}
					else{
						// if agency object not yet created, create it now
						var parentProp = this.mDetailPage.get('detailPage.parentProperty');
						var childProp = this.mDetailPage.get('detailPage.childProperty');
						var parent = {};
						parent[parentProp] = this.model.parentId;
						data[childProp] = parent;
					}
					this.mDetailObject.save(data)
					.done(function (response, status, xhrResponse) {
							modelFetch.resolve(response);
					})
					.fail(function (response, status, xhrResponse) {
						ViewManager.errorToWindow(response);
						modelFetch.reject();
					});
				} else {
					modelFetch.reject();
				}
			}
			else {
				var tables = this.$el.find('table');
				if (tables.length == 1) {
					var table = tables[0];

					//create the fk to the hansen detail
					var parentProp = self.mDetailPage.get('detailPage.parentProperty');
					var childProp = self.mDetailPage.get('detailPage.childProperty');
					var parent = {};
					parent[parentProp] = self.model.parentId;
					if (data[this.gridBind]) {
						data = data[this.gridBind];
					}
					if (_.isArray(data)) {
						if ( data.length == 0 ){
							modelFetch.resolve();
						}
						_.forEach(data, d => {
							d[childProp] = parent;

							var mDetailObject = new DetailObjectModel();
							mDetailObject = _.extend(mDetailObject, {'idAttribute': self.mDetailPage.get('detailPage.childPrimaryKey')});
							mDetailObject.moniker = self._getChildMoniker(true);
							mDetailObject.set(d);
							if (parseInt(mDetailObject.id) < 1000) {
								mDetailObject.unset(mDetailObject.idAttribute, {silent: true});
							}
							mDetailObject.save(null, {
								error: function (model, response, options) {
									ViewManager.errorToWindow(response, this);
								}
							})
								.done(function (response, status, xhrResponse) {
									modelFetch.resolve(response);
								})
								.fail(function (response, status, xhrResponse) {
									ViewManager.errorToWindow(response);
									modelFetch.reject();
								});
						});
						promises.push(this.removeDeletedRows());
					}
				}
			}

			$.when.apply($, promises).done(
				function (response, status, xhrResponse) {
					if (response?.data?.[0]?.userErrorMessages?.length) {
					var msgs = new IpsModelCollection(response.data[0].userErrorMessages);
					var customError = {};
					customError.validationError = {};
					customError.isCustomValidation = true;
					var index = 0;

					_.forEach(msgs.models, msg => {
						var bind = msg.get('propertyBind');
						var message = ViewManager.removeScriptInjection(msg.get('message'));
						if (message) {
							if (message.startsWith('{{') && message.endsWith('}}')) {
								message = i18n.t(message.substring(2, message.length - 2));
							}
						} else {
							message = '';
						}
						customError.validationError[bind] = message;
					});

					ViewManager.errorToWindow(customError, self);
					ViewManager.scrollToError(customError, self);
					ViewManager.loading(false);
					return; // stop reload
				}

				// no user errors → safe to reload
				window.removeEventListener("beforeunload", self.areYouSure.bind(this));
				self.enabled = false;
				window.location.reload(false);
				}).fail(function (response, status, xhrResponse) {
					if( response ){
						ViewManager.errorToWindow(response);
					}
					ViewManager.loading(false);
				});
		},
		templateHelpers: function () {
			var content = '';
			var childMoniker = '';
			if (this.mDetailPage) {
				content = this.mDetailPage.get('document');
				if (content && content.get) {
					content = content.toJSON();
				}
				childMoniker = this.mDetailPage.get('detailPage.childMoniker');
				this.mDetailPage.className = this.mDetailPage.className.split('.').join("");
			}

			//override the toggleEnabled value, if version is 11.1 Dec and 11.2 Jan
			if ( ViewManager.versionRange('8.7.0.1912', '8.8') || ViewManager.versionRange('8.8.0.2001') ) {
				var contentMode = (typeof this.model.get('contentMode') !== 'undefined') ? this.model.get('contentMode') : 'Empty'; //dummy text
				var closedStatus = this.aggregateModel.get('PortalStatus') ? this.aggregateModel.get('PortalStatus').toLowerCase() == 'closed' : false;
				if(contentMode.toLowerCase() == 'editable' && !closedStatus && !this.ineffectiveApplicant) {
					this.toggleEnabled = true;
				} else{
					this.toggleEnabled = false;
				}
			}

			return {
				doc: content,
				enabled: this.enabled,
				toggleEnabled: this.toggleEnabled,
				hasFields: this.hasFields === false ? false : true,
				detailOptions: {
					isGrid: this.isGrid,
					isAdd:this.isAdd
				},
				isExpanded: this.isExpanded(),
				childMoniker: childMoniker,
				dPName: (typeof this.mDetailPage == 'undefined') ? '': this.mDetailPage.className
			};
		},
	});
});
